import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/layouts/Layout";

const CareersPage = () => {
  const { id } = useParams();
  const [applicationForm, setApplicationForm] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    motivation: '',
    portfolio: ''
  });
  const [selectedJob, setSelectedJob] = useState(null);

  const jobOpenings = [
    {
      id: 1,
      title: "量子AIエンジニア",
      department: "R&D部門",
      location: "東京本社",
      type: "正社員",
      level: "シニア",
      urgent: true,
      description: "量子コンピューティングとAIの融合技術を開発する最先端ポジション",
      requirements: [
        "量子コンピューティングまたは機械学習の実務経験3年以上",
        "Python、Qiskit、Cirqなどの量子プログラミングフレームワークの使用経験",
        "修士号（物理学、コンピュータサイエンス、数学等）",
        "英語でのコミュニケーション能力"
      ],
      responsibilities: [
        "量子機械学習アルゴリズムの設計・実装",
        "量子リザーバコンピューティングの研究開発",
        "産業応用向け量子AIソリューションの開発",
        "研究論文の執筆・学会発表"
      ],
      skills: ["量子コンピューティング", "機械学習", "Python", "研究開発"],
      salary: "年収800万円〜1,500万円",
      benefits: ["ストックオプション", "研究費支給", "学会参加費支援"]
    },
    {
      id: 2,
      title: "シニアAIエンジニア",
      department: "プロダクト開発部",
      location: "東京本社",
      type: "正社員",
      level: "シニア",
      urgent: false,
      description: "産業用AIソリューションの設計・開発をリードするポジション",
      requirements: [
        "機械学習・深層学習の実務経験5年以上",
        "Python、TensorFlow/PyTorchの豊富な経験",
        "MLOpsの実装経験",
        "チームリーダーとしての経験"
      ],
      responsibilities: [
        "AIモデルの設計・開発・デプロイ",
        "機械学習パイプラインの構築・運用",
        "ジュニアエンジニアの技術指導",
        "顧客要件の技術的検討・提案"
      ],
      skills: ["機械学習", "Python", "MLOps", "リーダーシップ"],
      salary: "年収700万円〜1,200万円",
      benefits: ["リモートワーク可", "技術書購入支援", "資格取得支援"]
    },
    {
      id: 3,
      title: "データサイエンティスト",
      department: "データ分析部",
      location: "東京本社・大阪支社",
      type: "正社員",
      level: "ミドル",
      urgent: true,
      description: "ビッグデータから価値ある洞察を導き出し、ビジネス成長を支援",
      requirements: [
        "データサイエンス実務経験3年以上",
        "統計学・機械学習の深い理解",
        "SQL、Python/Rでのデータ分析経験",
        "ビジネス課題解決の経験"
      ],
      responsibilities: [
        "ビッグデータの分析・可視化",
        "予測モデルの構築・評価",
        "ビジネス指標の設計・監視",
        "分析結果のレポート作成・プレゼン"
      ],
      skills: ["統計学", "Python/R", "SQL", "データ可視化"],
      salary: "年収600万円〜1,000万円",
      benefits: ["フレックスタイム", "副業可", "研修費用補助"]
    },
    {
      id: 4,
      title: "フロントエンドエンジニア",
      department: "プロダクト開発部",
      location: "東京本社",
      type: "正社員",
      level: "ミドル",
      urgent: false,
      description: "AIプロダクトのユーザーインターフェース開発を担当",
      requirements: [
        "React/Vue.jsでの開発経験3年以上",
        "TypeScript、HTML5、CSS3の豊富な経験",
        "レスポンシブデザインの実装経験",
        "UX/UIデザインの理解"
      ],
      responsibilities: [
        "Webアプリケーションのフロントエンド開発",
        "UIコンポーネントの設計・実装",
        "パフォーマンス最適化",
        "デザイナーとの協業"
      ],
      skills: ["React", "TypeScript", "UI/UX", "レスポンシブデザイン"],
      salary: "年収550万円〜900万円",
      benefits: ["リモートワーク可", "最新機器支給", "勉強会参加支援"]
    },
    {
      id: 5,
      title: "プロダクトマネージャー",
      department: "プロダクト企画部",
      location: "東京本社",
      type: "正社員",
      level: "シニア",
      urgent: true,
      description: "AIプロダクトの企画・戦略立案からリリースまでを統括",
      requirements: [
        "プロダクトマネジメント経験5年以上",
        "AI/ML分野でのプロダクト開発経験",
        "アジャイル開発の実務経験",
        "ビジネス戦略立案能力"
      ],
      responsibilities: [
        "プロダクトロードマップの策定",
        "市場分析・競合分析",
        "開発チームとの連携・調整",
        "ステークホルダーとのコミュニケーション"
      ],
      skills: ["プロダクトマネジメント", "AI/ML", "アジャイル", "戦略立案"],
      salary: "年収800万円〜1,400万円",
      benefits: ["ストックオプション", "海外研修", "英語学習支援"]
    },
    {
      id: 6,
      title: "MLOpsエンジニア",
      department: "インフラ・運用部",
      location: "東京本社",
      type: "正社員",
      level: "ミドル",
      urgent: false,
      description: "機械学習モデルの運用基盤構築・自動化を推進",
      requirements: [
        "MLOps/DevOpsの実務経験3年以上",
        "Kubernetes、Dockerの運用経験",
        "CI/CDパイプラインの構築経験",
        "AWS/GCP/Azureでのクラウド運用経験"
      ],
      responsibilities: [
        "ML基盤の設計・構築・運用",
        "CI/CDパイプラインの自動化",
        "モニタリング・ログ管理システム構築",
        "セキュリティ・コンプライアンス対応"
      ],
      skills: ["MLOps", "Kubernetes", "CI/CD", "クラウド"],
      salary: "年収650万円〜1,100万円",
      benefits: ["フレックスタイム", "資格取得支援", "技術カンファレンス参加"]
    }
  ];

  const companyBenefits = [
    {
      category: "働き方",
      items: [
        "フレックスタイム制（コアタイム: 10:00-15:00）",
        "リモートワーク制度（週3回まで）",
        "有給取得率90%以上",
        "育児・介護休暇制度"
      ]
    },
    {
      category: "成長・学習",
      items: [
        "書籍・研修費用補助（年間30万円まで）",
        "カンファレンス・学会参加支援",
        "社内勉強会・技術共有会",
        "英語研修・語学学習支援"
      ]
    },
    {
      category: "報酬・評価",
      items: [
        "ストックオプション制度",
        "成果に応じたボーナス",
        "年2回の昇進・昇格機会",
        "360度フィードバック制度"
      ]
    },
    {
      category: "福利厚生",
      items: [
        "社会保険完備",
        "退職金制度",
        "健康診断・人間ドック補助",
        "社員食堂・ドリンク無料"
      ]
    }
  ];

  const handleApplicationSubmit = (e) => {
    e.preventDefault();
    console.log('Application submitted:', applicationForm);
    alert('応募を受け付けました！選考結果は1週間以内にご連絡いたします。');
    setApplicationForm({
      name: '',
      email: '',
      phone: '',
      position: '',
      experience: '',
      motivation: '',
      portfolio: ''
    });
  };

  // 個別求人詳細表示
  if (id) {
    const job = jobOpenings.find(j => j.id === parseInt(id));
    if (!job) return <div>求人が見つかりません</div>;

    return (
      <Layout 
        title={job.title} 
        subtitle={`${job.department} - ${job.type}`}
      >
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="premium-card" style={{ 
                  padding: '40px',
                  marginBottom: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                    <div style={{ fontSize: '64px', marginRight: '20px' }}>{job.icon}</div>
                    <div>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                        <span style={{ 
                          background: '#1e40af', 
                          color: 'white', 
                          padding: '4px 12px', 
                          borderRadius: '20px',
                          fontSize: '12px'
                        }}>
                          {job.department}
                        </span>
                        <span style={{ 
                          background: job.urgent ? '#dc2626' : '#059669', 
                          color: 'white', 
                          padding: '4px 12px', 
                          borderRadius: '20px',
                          fontSize: '12px'
                        }}>
                          {job.urgent ? '急募' : '通常募集'}
                        </span>
                      </div>
                      <h2 style={{ color: '#3b82f6', marginBottom: '10px' }}>{job.title}</h2>
                      <p style={{ color: '#cbd5e1', marginBottom: '10px' }}>{job.description}</p>
                      <div style={{ color: '#10b981', fontWeight: 'bold' }}>{job.salary}</div>
                    </div>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>📋 業務内容</h4>
                    <ul style={{ color: '#cbd5e1', marginLeft: '20px' }}>
                      {job.responsibilities.map((item, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {item}</li>
                      ))}
                    </ul>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>✅ 必須要件</h4>
                    <ul style={{ color: '#cbd5e1', marginLeft: '20px' }}>
                      {job.requirements.map((item, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {item}</li>
                      ))}
                    </ul>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>歓迎要件</h4>
                    <ul style={{ color: '#94a3b8', marginLeft: '20px' }}>
                      {job.preferred.map((item, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {item}</li>
                      ))}
                    </ul>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>待遇・福利厚生</h4>
                    <ul style={{ color: '#10b981', marginLeft: '20px' }}>
                      {job.benefits.map((item, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* 応募フォーム */}
                <div className="premium-card" style={{ 
                  padding: '40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h3 style={{ color: '#3b82f6', marginBottom: '20px' }}>📝 応募フォーム</h3>
                  
                  <form onSubmit={handleApplicationSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ marginBottom: '20px' }}>
                          <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                            お名前 *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={applicationForm.name}
                            onChange={(e) => setApplicationForm({...applicationForm, name: e.target.value})}
                            required
                            style={{ 
                              background: 'rgba(30, 41, 59, 0.8)',
                              border: '1px solid #475569',
                              color: '#e2e8f0'
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ marginBottom: '20px' }}>
                          <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                            メールアドレス *
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            value={applicationForm.email}
                            onChange={(e) => setApplicationForm({...applicationForm, email: e.target.value})}
                            required
                            style={{ 
                              background: 'rgba(30, 41, 59, 0.8)',
                              border: '1px solid #475569',
                              color: '#e2e8f0'
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ marginBottom: '20px' }}>
                          <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                            電話番号
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            value={applicationForm.phone}
                            onChange={(e) => setApplicationForm({...applicationForm, phone: e.target.value})}
                            style={{ 
                              background: 'rgba(30, 41, 59, 0.8)',
                              border: '1px solid #475569',
                              color: '#e2e8f0'
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ marginBottom: '20px' }}>
                          <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                            希望職種 *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={job.title}
                            readOnly
                            style={{ 
                              background: 'rgba(30, 41, 59, 0.8)',
                              border: '1px solid #475569',
                              color: '#e2e8f0'
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                        経験・スキル *
                      </label>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={applicationForm.experience}
                        onChange={(e) => setApplicationForm({...applicationForm, experience: e.target.value})}
                        placeholder="関連する経験、スキル、資格などをご記入ください"
                        required
                        style={{ 
                          background: 'rgba(30, 41, 59, 0.8)',
                          border: '1px solid #475569',
                          color: '#e2e8f0'
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                        志望動機 *
                      </label>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={applicationForm.motivation}
                        onChange={(e) => setApplicationForm({...applicationForm, motivation: e.target.value})}
                        placeholder="なぜDeepTeLLで働きたいのか、この職種に応募する理由をお聞かせください"
                        required
                        style={{ 
                          background: 'rgba(30, 41, 59, 0.8)',
                          border: '1px solid #475569',
                          color: '#e2e8f0'
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                      <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                        ポートフォリオ・参考資料URL
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        value={applicationForm.portfolio}
                        onChange={(e) => setApplicationForm({...applicationForm, portfolio: e.target.value})}
                        placeholder="GitHub、個人サイト、作品集などのURLをお聞かせください"
                        style={{ 
                          background: 'rgba(30, 41, 59, 0.8)',
                          border: '1px solid #475569',
                          color: '#e2e8f0'
                        }}
                      />
                    </div>

                    <button 
                      type="submit" 
                      className="btn btn-custom btn-lg"
                      style={{ width: '100%' }}
                    >
                                              応募する
                    </button>
                  </form>
                </div>
              </div>

              <div className="col-md-4">
                {/* 求人基本情報 */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  marginBottom: '20px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>📋 募集要項</h4>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>雇用形態:</strong>
                    <p style={{ color: '#94a3b8', margin: '5px 0' }}>{job.type}</p>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>勤務地:</strong>
                    <p style={{ color: '#94a3b8', margin: '5px 0' }}>{job.location}</p>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>レベル:</strong>
                    <p style={{ color: '#94a3b8', margin: '5px 0' }}>{job.level}</p>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <strong style={{ color: '#cbd5e1' }}>給与:</strong>
                    <p style={{ color: '#10b981', margin: '5px 0', fontWeight: 'bold' }}>{job.salary}</p>
                  </div>
                </div>

                {/* 他の職種 */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>🔗 他の募集職種</h4>
                  {jobOpenings
                    .filter(j => j.id !== job.id)
                    .slice(0, 3)
                    .map((otherJob) => (
                      <div key={otherJob.id} style={{ marginBottom: '15px', cursor: 'pointer' }}
                           onClick={() => window.location.href = `/careers/${otherJob.id}`}>
                        <div style={{ 
                          padding: '15px',
                          border: '1px solid rgba(59, 130, 246, 0.2)',
                          borderRadius: '8px',
                          transition: 'all 0.2s'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            <span style={{ fontSize: '24px', marginRight: '10px' }}>{otherJob.icon}</span>
                            <h6 style={{ color: '#f1f5f9', margin: 0, fontSize: '14px' }}>
                              {otherJob.title}
                            </h6>
                          </div>
                          <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>
                            {otherJob.department}
                          </p>
                        </div>
                      </div>
                    ))}
                  
                  <a href="/careers" className="btn btn-outline-custom btn-sm" style={{ 
                    width: '100%',
                    color: '#3b82f6',
                    borderColor: '#3b82f6'
                  }}>
                    全ての求人を見る
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  // 求人一覧表示
  return (
    <Layout 
      title="採用情報" 
      subtitle="世界を変えるAI技術の開発に参加し、あなたの可能性を最大限に発揮しませんか"
    >
      {/* 会社紹介 */}
      <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h2 style={{ color: '#3b82f6', marginBottom: '20px' }}>一緒に未来を創造しませんか？</h2>
                <p style={{ color: '#cbd5e1', fontSize: '18px', lineHeight: '1.6' }}>
                  DeepTeLLでは、量子コンピューティングとAI技術の融合による次世代ソリューションの開発に取り組んでいます。
                  私たちと一緒に、テクノロジーの可能性を追求し、社会にポジティブなインパクトを与える仕事をしませんか。
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>Tech</div>
                <h4 style={{ color: '#f1f5f9', marginBottom: '10px' }}>最先端技術</h4>
                <p style={{ color: '#94a3b8' }}>
                  量子AI技術の最前線で、世界トップレベルの技術に携わることができます
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>Growth</div>
                <h4 style={{ color: '#f1f5f9', marginBottom: '10px' }}>成長環境</h4>
                <p style={{ color: '#94a3b8' }}>
                  学習支援制度が充実しており、継続的にスキルアップできる環境を提供しています
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>Global</div>
                <h4 style={{ color: '#f1f5f9', marginBottom: '10px' }}>グローバル展開</h4>
                <p style={{ color: '#94a3b8' }}>
                  国際的なプロジェクトに参加し、世界規模での事業展開を経験できます
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 募集職種 */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>募集職種</h2>
                <p style={{ color: '#cbd5e1' }}>
                  様々な分野のプロフェッショナルを募集しています
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            {jobOpenings.map((job) => (
              <div key={job.id} className="col-md-6" style={{ marginBottom: '30px' }}>
                <div 
                  className="premium-card" 
                  style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onClick={() => setSelectedJob(job)}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <span style={{ 
                        background: '#1e40af', 
                        color: 'white', 
                        padding: '4px 8px', 
                        borderRadius: '12px',
                        fontSize: '11px'
                      }}>
                        {job.level}
                      </span>
                      {job.urgent && (
                        <span style={{ 
                          background: '#dc2626', 
                          color: 'white', 
                          padding: '4px 8px', 
                          borderRadius: '12px',
                          fontSize: '11px'
                        }}>
                          急募
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 style={{ color: '#f1f5f9', marginBottom: '10px', fontSize: '18px' }}>
                    {job.title}
                  </h3>

                  <p style={{ color: '#94a3b8', marginBottom: '15px', fontSize: '14px' }}>
                    {job.description}
                  </p>

                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    background: 'rgba(59, 130, 246, 0.1)',
                    padding: '10px',
                    borderRadius: '8px',
                    marginBottom: '15px'
                  }}>
                    <div>
                      <div style={{ color: '#94a3b8', fontSize: '12px' }}>部署</div>
                      <div style={{ color: '#3b82f6', fontWeight: 'bold', fontSize: '14px' }}>{job.department}</div>
                    </div>
                    <div>
                      <div style={{ color: '#94a3b8', fontSize: '12px' }}>勤務地</div>
                      <div style={{ color: '#3b82f6', fontWeight: 'bold', fontSize: '14px' }}>{job.location}</div>
                    </div>
                  </div>

                  <div style={{ 
                    color: '#10b981', 
                    fontWeight: 'bold', 
                    fontSize: '16px',
                    marginBottom: '15px' 
                  }}>
                    {job.salary}
                  </div>

                  <div style={{ textAlign: 'right' }}>
                    <span style={{ color: '#3b82f6', fontSize: '14px' }}>
                      詳細を見る →
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 福利厚生 */}
      <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>福利厚生</h2>
                <p style={{ color: '#cbd5e1' }}>
                  働きやすい環境と充実した制度をご用意しています
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            {companyBenefits.map((benefit, index) => (
              <div key={index} className="col-md-3" style={{ marginBottom: '30px' }}>
                <div className="premium-card" style={{ 
                  padding: '25px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '15px', textAlign: 'center' }}>
                    {benefit.category}
                  </h4>
                  <ul style={{ color: '#cbd5e1', listStyle: 'none', marginLeft: 0 }}>
                    {benefit.items.map((item, itemIndex) => (
                      <li key={itemIndex} style={{ marginBottom: '8px', fontSize: '14px' }}>
                        • {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA セクション */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                あなたの挑戦をお待ちしています
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                世界を変える技術開発に参加し、あなたのキャリアを次のレベルへ押し上げませんか。
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="#jobs" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                                            求人を見る
                </a>
                <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                  採用担当に相談
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 職種詳細モーダル */}
      {selectedJob && (
        <div style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }} onClick={() => setSelectedJob(null)}>
          <div style={{ 
            background: '#1e293b',
            borderRadius: '12px',
            padding: '40px',
            maxWidth: '800px',
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            border: '1px solid rgba(59, 130, 246, 0.2)'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div>
                <h2 style={{ color: '#f1f5f9', marginBottom: '10px' }}>{selectedJob.title}</h2>
                <p style={{ color: '#94a3b8', fontSize: '16px' }}>{selectedJob.description}</p>
              </div>
              <button 
                onClick={() => setSelectedJob(null)}
                style={{ 
                  background: 'none',
                  border: 'none',
                  color: '#94a3b8',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>募集要項</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                <div>
                  <span style={{ color: '#cbd5e1', fontSize: '14px' }}>部署</span>
                  <p style={{ color: '#f1f5f9', margin: '5px 0' }}>{selectedJob.department}</p>
                </div>
                <div>
                  <span style={{ color: '#cbd5e1', fontSize: '14px' }}>勤務地</span>
                  <p style={{ color: '#f1f5f9', margin: '5px 0' }}>{selectedJob.location}</p>
                </div>
                <div>
                  <span style={{ color: '#cbd5e1', fontSize: '14px' }}>雇用形態</span>
                  <p style={{ color: '#f1f5f9', margin: '5px 0' }}>{selectedJob.type}</p>
                </div>
                <div>
                  <span style={{ color: '#cbd5e1', fontSize: '14px' }}>年収</span>
                  <p style={{ color: '#f1f5f9', margin: '5px 0' }}>{selectedJob.salary}</p>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>応募要件</h4>
              <ul style={{ color: '#cbd5e1', paddingLeft: '20px' }}>
                {selectedJob.requirements.map((req, index) => (
                  <li key={index} style={{ marginBottom: '8px' }}>{req}</li>
                ))}
              </ul>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>主な業務内容</h4>
              <ul style={{ color: '#cbd5e1', paddingLeft: '20px' }}>
                {selectedJob.responsibilities.map((resp, index) => (
                  <li key={index} style={{ marginBottom: '8px' }}>{resp}</li>
                ))}
              </ul>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>福利厚生</h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {selectedJob.benefits.map((benefit, index) => (
                  <span key={index} style={{ 
                    background: 'rgba(59, 130, 246, 0.2)',
                    color: '#3b82f6',
                    padding: '6px 12px',
                    borderRadius: '12px',
                    fontSize: '14px'
                  }}>
                    {benefit}
                  </span>
                ))}
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <a href="/contact" className="btn btn-custom btn-lg">
                この職種に応募する
              </a>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default CareersPage; 